import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertService } from 'services/alert.service';
import { FriendDetailsService } from 'services/frienddetails.service';
import { NavigationService } from 'services/navigation.service';
import { UserBankDetailsService } from 'services/userbankdetails.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-redeempopup',
  templateUrl: './redeempopup.component.html',
  styleUrls: ['./redeempopup.component.scss']
})
export class RedeempopupComponent implements OnInit {
  dropdownSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  form: FormGroup;
  accountTypeList: any;
  bankList: any[];
  branchCode: any;
  bankDetails: any;
  userData: any;
  isDisabled: boolean = false;
  
  constructor( @Inject(MAT_DIALOG_DATA) data: any,   
    private formBuilder: FormBuilder,    
    private alertService: AlertService,  
    private friendDetailsService: FriendDetailsService,
    private navigationService : NavigationService,
    private userBankDetailsService: UserBankDetailsService,
    public dialogRef: MatDialogRef<RedeempopupComponent>,
  ) {
     
    this.userData =  data;
    this.bankDetails =  data.userBankDetails;

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'Un Select All',
      itemsShowLimit: 4,
      allowSearchFilter: true
  };


   }

  ngOnInit() {
  
    this.getAccountType(true);
    this.getBankDetails(true);
    this.initializeValidators();
    // this.form.patchValue(this.bankDetails.userBankDetails);
    this.isDisabled = this.userData.isBankDetailsAvailable;
  } 

   initializeValidators() {
      this.form = this.formBuilder.group({  
        accountHolderName: [this.bankDetails.accountHolderName, [Validators.required]],    
        bank: [this.bankDetails.bank, [Validators.required]],
        branchCode: [this.bankDetails.branchCode, [Validators.required]],
        accountNumber: [this.bankDetails.accountNumber, [Validators.required]],
        accountType: [this.bankDetails.accountType, [Validators.required]],
        id:[this.bankDetails.id],
        userId:[this.bankDetails.userId]
        });
    }


  getAccountType(refresh) {    
    this.friendDetailsService.getAccountType(refresh).subscribe(result => {
        this.accountTypeList = [];
        this.accountTypeList = result;
    });
}

getBankDetails(refresh) {    
  this.friendDetailsService.getBankDetails(refresh).subscribe(result => {
      this.bankList = [];
      this.bankList = result;
  });
}

onSubmit() {  
    if (this.form.valid)
     {    
    this.userBankDetailsService.save(this.form.value).subscribe(result => {
      this.dialogRef.close(result); 
      if (result) {
        if(result)
        {
          swal.fire({
            text: "Your request was sent successfully",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then((res) => {
            if (res.value) {
              // this.navigationService.goToDashboard();
            }
          });
        }     
      }
    });
  } else {
    this.validateFormControl();
  }
}

onCancel()
{
  this.dialogRef.close();
  this.navigationService.goToDashboard();
}

validateFormControl() {
  Object.keys(this.form.controls).forEach(field => {
    const control = this.form.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({
        onlySelf: true
      });
    }
  })
}

  bankChange(event) {

    var bankValue = this.bankList.filter(item => {
     return item.name.includes(this.form.value.bank);
    });
    this.branchCode = bankValue[0].code;
    this.form.controls['branchCode'].setValue(this.branchCode);
 }
 
 accountTypeChange  (event) {

}





}
